// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M22 2V22H20V2H22ZM2 2H18V22H2V2Z"}}]};

const ScrollBarFilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'scroll-bar-filled',
    ref,
    icon: element,
  },
));

ScrollBarFilledIcon.displayName = 'ScrollBarFilledIcon';

export default ScrollBarFilledIcon;
